export default () => {

    const form = document.querySelector('[data-subscribe-form]');
    if (form) {
        form.addEventListener('submit', (e) => {

            e.preventDefault();
            const button = form.querySelector('button');
            const data = new FormData(form);

            const xhr = new XMLHttpRequest();
            xhr.open('POST', form.getAttribute('action'));
            xhr.onload = () => {
                if (xhr.status === 200) {
                    form.reset();
                    const message = document.createElement('DIV');
                    message.innerHTML = '<i>Subscribed!</i>';
                    button.parentNode.append(message);
                }
            }
            xhr.send(data);
            return false;

        });
    }

}
